export const DISCOUNT_PRICE = 0.97;
